!((document, Drupal, $) => {
  'use strict';

  Drupal.behaviors.hero = {
    attach: function() {
      var heros = document.querySelectorAll('.hero');

      if (heros) {
        for (let i = 0; i < heros.length; i++) {
          let heroItem = heros.item(parseInt(i));
          let heroVideo = heroItem.querySelector('video');

          if (heroVideo) {
            var heroVideoChild = heroVideo.childNodes.item(1);
            heroVideoChild.setAttribute(
              'src',
              heroVideoChild.getAttribute('data-src')
            );
            heroVideo.load();

            // eslint-disable-next-line no-inner-declarations
            function pauseVideo(e) {
              e.preventDefault();

              var heroVideo = heroItem.querySelector('video');
              heroVideo.pause();

              e.target.classList.add('hideButton');

              var playButton = heroItem.querySelector('.play');
              playButton.classList.remove('hideButton');
            }

            // eslint-disable-next-line no-inner-declarations
            function playVideo(e) {
              e.preventDefault();

              var heroVideo = heroItem.querySelector('video');
              heroVideo.play();

              e.target.classList.add('hideButton');

              var pauseButton = heroItem.querySelector('.pause');
              pauseButton.classList.remove('hideButton');
            }

            var pauseButton = heroItem.querySelector('.pause');
            pauseButton.addEventListener('click', pauseVideo ,{passive: true});

            var playButton = heroItem.querySelector('.play');
            playButton.addEventListener('click', playVideo ,{passive: true});
          }

          let scrollButton = $(heroItem).find('.arrow-button--down');
          var headerHeight = $('.region-header').outerHeight();
          var targetElement = scrollButton.find('a').attr('href');
          targetElement = $(targetElement);
          scrollButton.click(function () {
            if (targetElement.length) {
              var offset = targetElement.offset().top - headerHeight;
              $('html, body').animate({
                  scrollTop: offset
              }, 'slow');
            }
          });
        }
      }

    }
  };
})(document, Drupal, jQuery);
